export default __webpack_public_path__ + "static/media/heart_full.a9f7a248.svg";